(function () {
  const root = document.querySelector('[data-bcm-promotion]');
  if (!root) return;

  if (navigator.share) {
    const shareLink = root.querySelector('[data-bcm-share]');
    if (shareLink) {
      shareLink.addEventListener('click', function (event) {
        event.preventDefault();
        navigator.share({
          title: document.title,
          url: window.location.href,
        }).catch(function () {});
      });
    }
  }

  initParallax(root);
  initBuyNowLoading(root);
  initCartLink(root);
})();

function initCartLink(root) {
  const link = root.querySelector('[data-bcm-cart-link]');
  if (!link) return;

  const baseLabel = link.dataset.bcmCartLabel || 'Cart';
  const labelText = link.querySelector('[data-bcm-cart-label-text]');
  const countBadge = link.querySelector('[data-bcm-cart-count-badge]');
  const countValue = link.querySelector('[data-bcm-cart-count-value]');

  function formatCountDisplay(count) {
    return count < 100 ? String(count) : '99+';
  }

  function setCartCount(count) {
    const safeCount = Math.max(0, parseInt(count, 10) || 0);
    link.dataset.bcmCartCount = String(safeCount);
    if (labelText) labelText.textContent = baseLabel;
    if (countValue) countValue.textContent = formatCountDisplay(safeCount);
    if (countBadge) countBadge.classList.toggle('bcm-header__cart-count--empty', safeCount === 0);
  }

  setCartCount(link.dataset.bcmCartCount);

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        setCartCount(cart.item_count);
      })
      .catch(function () {});
  });
}

function initBuyNowLoading(root) {
  const form = root.querySelector('.bcm-hero__buy-form');
  if (!form) return;

  form.addEventListener('submit', function () {
    const button = form.querySelector('[data-bcm-buy-now]');
    if (!button || button.disabled) return;

    button.disabled = true;
    button.classList.add('loading');
    button.setAttribute('aria-busy', 'true');
  });
}

function initParallax(root) {
  root.querySelectorAll('[data-bcm-parallax]').forEach(initParallaxRegion);
}

function initParallaxRegion(parallax) {
  const region = parallax.closest('.bcm-hero, .bcm-cta');
  if (!region) return;

  const items = parallax.querySelectorAll('[data-depth]');
  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const seedOffset = region.classList.contains('bcm-cta') ? 50000 : 0;
  const configs = Array.from(items, function (item, index) {
    return createParallaxConfig(item, index + seedOffset);
  });
  const motion = { x: 0, y: 0, scroll: 0 };
  let rafId = null;

  function applyParallax() {
    items.forEach(function (item, index) {
      const config = configs[index];
      const moveX = motion.x * config.xMul;
      const moveY = motion.y * config.yMul + motion.scroll * config.scrollMul;
      const tilt = motion.x * config.tiltX + motion.y * config.tiltY;

      item.style.setProperty('--bcm-parallax-x', moveX.toFixed(2) + 'px');
      item.style.setProperty('--bcm-parallax-y', moveY.toFixed(2) + 'px');
      item.style.setProperty('--bcm-parallax-tilt', tilt.toFixed(2) + 'deg');
    });
    rafId = null;
  }

  function scheduleParallax() {
    if (rafId === null) {
      rafId = window.requestAnimationFrame(applyParallax);
    }
  }

  region.addEventListener('mousemove', function (event) {
    const rect = region.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    motion.x = (event.clientX - rect.left) / rect.width - 0.5;
    motion.y = (event.clientY - rect.top) / rect.height - 0.5;
    scheduleParallax();
  });

  region.addEventListener('mouseleave', function () {
    motion.x = 0;
    motion.y = 0;
    scheduleParallax();
  });

  window.addEventListener(
    'scroll',
    function () {
      const rect = region.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      motion.scroll = Math.min(Math.max(0, -rect.top), rect.height) * 0.35;
      scheduleParallax();
    },
    { passive: true }
  );

  scheduleParallax();
}

function createParallaxConfig(item, index) {
  const rand = seededRandom(index * 7919 + 104729);
  const depth = (parseFloat(item.dataset.depth) || 0.15) * (0.72 + rand() * 0.65);
  const xSign = rand() > 0.32 ? 1 : -1;
  const ySign = rand() > 0.32 ? 1 : -1;
  const xBias = 0.3 + rand() * 1.5;
  const yBias = 0.3 + rand() * 1.5;
  const baseMove = 48;

  return {
    xMul: depth * xSign * xBias * baseMove,
    yMul: depth * ySign * yBias * baseMove,
    scrollMul: depth * (0.35 + rand() * 1.05),
    tiltX: (rand() - 0.5) * 16,
    tiltY: (rand() - 0.5) * 12,
  };
}

function seededRandom(seed) {
  let state = seed % 2147483647;
  if (state <= 0) state += 2147483646;

  return function () {
    state = (state * 16807) % 2147483647;
    return (state - 1) / 2147483646;
  };
}
